import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetKeycloakImportUsersResponse extends BackendResponse {
  users: KeycloakImportUser[];
}

export interface GetKeycloakImportUsersParameters extends NextApiParams {
  /** Optional: only return rows for this concern. */
  concernId?: number;
}

/** VPN-only debug endpoint: 'Visma Connect' AccountLink rows joined with
 *  alleaktivebrukere, in Keycloak's partial-import shape ({ users: [...] }). */
export const getKeycloakImportUsers = withNextApi<
  GetKeycloakImportUsersResponse,
  GetKeycloakImportUsersParameters
>("/auth/GetKeycloakImportUsers", {
  method: "GET",
});

/** One user in the Keycloak partial-import JSON format. */
export interface KeycloakImportUser {
  username: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  enabled: boolean;
  emailVerified: boolean;
}
